export default __webpack_public_path__ + "static/media/checkbox-icon.1f8a8a48.svg";